import { classInstance } from '@/shared/helpers/helpers';


/**
 * @desc Сообщение об ошибке формы.
 * @category 3 Form
 * @example
 * document.querySelectorAll('.js-form-message').forEach((element) => {new ErrorMessage(element)});
 * @constructor
 * @param {HTMLFormElement} selector HTML-элемент
 */

export class FormMessage {
	private readonly element: HTMLElement | null = null;
	private readonly activeClass: string = 'form-message--active';
	private readonly typeClasses: Record<string, string> = {
		error: 'form-message--error',
		success: 'form-message--success',
		warning: 'form-message--warning',
	};

	constructor(element: HTMLElement) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	/**
	 * @description Отображение сообщения.
	 * @param {string} message Текст сообщения.
	 * @param {string} type Тип сообщения: error — ошибка, warning — предупреждение, success — успех.
	 * @example
	 * const message = app.classInstance.get(document.querySelector('.js-form-message'));
	 * myForm.errorMessage.set('Ошибка', 'error');
	 */
	public set = (message: string | null, type?: string): void => {
		if (type && this.typeClasses[type]) {
			Object.values(this.typeClasses).forEach((value) => this.element.classList.remove(value));
			this.element.classList.add(this.typeClasses[type]);
		}
		this.element.innerHTML = message || this.element.innerHTML;
		this.element.classList.add(this.activeClass);
	};

	/**
	 * @description Скрытие ошибки.
	 * @example
	 * const message = app.classInstance.get(document.querySelector('.js-form-message'));
	 * myForm.errorMessage.disable();
	 */
	public disable = () => {
		this.element.classList.remove(this.activeClass);
	};

	/**
	 * Инициализация экземпляра
	 */
	public init = (): void => classInstance.set(this.element, { errorMessage: this });

	/**
	 * Удаление экземпляра
	 */
	public destroy = (): void => classInstance.del(this.element, 'errorMessage');
}
